/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function UserDetailsError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'UserDetailsError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  UserDetailsError.prototype = Object.create(Error.prototype);
  UserDetailsError.prototype.constructor = UserDetailsError;
  
export { UserDetailsError }

@inject(HttpClient, apiUrl)
export class UserDetailsClient {

    constructor(public client: fetchClient, public url: string) { }
	
	userDetails_userDetails() : Promise<UserDetailsUserDetailsResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `query userDetails {
  me {
    id
    name
    emailAddress
    isAuthenticated
    isAdmin
    isFullyAuthenticated
    applicationIds
    expired
  }
}
`,
                variables : {
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new UserDetailsError("http error running 'userDetails_userDetails', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new UserDetailsError("graphql error(s) running 'userDetails_userDetails', see errors collection fro more details", response, json)
                    }

                    const result: any = UserDetailsUserDetailsResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class UserDetailsUserDetailsResult {
		me? :UserResult;

    static fromJS(json:any):UserDetailsUserDetailsResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new UserDetailsUserDetailsResult();

result.me= UserResult.fromJS(json["me"]);

        return result;
    }
}

export class UserResult {
		id? :string;
		name? :string;
		emailAddress? :string;
		isAuthenticated :boolean;
		isAdmin :boolean;
		isFullyAuthenticated :boolean;
		applicationIds? :Array<string>;
		expired :boolean;

    static fromJS(json:any):UserResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new UserResult();

	result.id = json["id"];
	result.name = json["name"];
	result.emailAddress = json["emailAddress"];
	result.isAuthenticated = json["isAuthenticated"];
	result.isAdmin = json["isAdmin"];
	result.isFullyAuthenticated = json["isFullyAuthenticated"];
	result.applicationIds = json["applicationIds"];
	result.expired = json["expired"];

        return result;
    }
}


